<template>
    <div class="exam-page-container full-screen">
      <ExamHeader />
      <!-- 主体内容 -->
      <div class="exam-content">
        <component :is="currentExamComponent" />
      </div>
    </div>
</template>

<script>
import { ElButton, ElRadioGroup, ElRadio, ElRow, ElCol, ElCard, ElCheckboxGroup, ElCheckbox, ElIcon } from "element-plus";
import { Flag } from '@element-plus/icons-vue';
import ExamHeader from "@/components/ExamHeader.vue";
import SelectExam from "./components/SelectExam.vue";
import OperationExam from "./components/OperationExam.vue";

export default {
  name: "ExamPage",
  components: {
    ExamHeader,
    SelectExam,
    OperationExam,
    ElButton,
    ElRadioGroup,
    ElRadio,
    ElRow,
    ElCol,
    ElCard,
    ElCheckboxGroup,
    ElCheckbox,
    ElIcon,
    Flag
  },
  data() {
    return {
      currentExamComponent: null
    };
  },
  mounted() {
    const joinedExam = JSON.parse(localStorage.getItem('joined_exam'));
    console.log('joinedExam.examSubject == > ', joinedExam.examSubject);
    if (joinedExam && joinedExam.examSubject === '理论知识') {
      this.currentExamComponent = 'SelectExam';
    } else if (joinedExam && joinedExam.examSubject === '操作技能') {
      this.currentExamComponent = 'OperationExam';
    }
  }
};
</script>

<style scoped>
.full-screen {
  height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>